import { dataLocationCopy } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLocationCopy = /*#__PURE__*/createIcon(dataLocationCopy)
export default IconLocationCopy
